// Balance Ledger Action Types
export const FETCH_BALANCE_LEDGER_RESOLVED = 'FETCH_BALANCE_LEDGER_RESOLVED';
export const FETCH_BALANCE_LEDGER_FAILED = 'FETCH_BALANCE_LEDGER_FAILED';
export const CLEAR_BALANCE_LEDGER = 'CLEAR_BALANCE_LEDGER';
